import { getCookies, removeCookies, setCookies } from './CookieHelper';

export const USER_TOKEN_COOKIE_NAME = process.env.REACT_APP_USERTOKEN_COOKIE_NAME;
export const USER_PROFILE_COOKIE_NAME = 'ormprofile';

export const getSessionToken = () => getCookies(USER_TOKEN_COOKIE_NAME);

export const setSessionToken = (token, expiryAfterMinutes = 86400) =>
  setCookies(USER_TOKEN_COOKIE_NAME, token, expiryAfterMinutes);

export const getSessionProfile = () => getCookies(USER_PROFILE_COOKIE_NAME);

export const setSessionProfile = (profile, expiryAfterMinutes = 86400) =>
  setCookies(USER_PROFILE_COOKIE_NAME, profile, expiryAfterMinutes);

export const clearSession = () => {
  removeCookies(USER_TOKEN_COOKIE_NAME);
  removeCookies(USER_PROFILE_COOKIE_NAME);
};
